import React from "react";

const Article = () => {
  return (
    <div>
      <div className="mb-20">
        <h2 id="overview" className="mt-[-5px]">
          Contribution
        </h2>
        <hr className="dividergeneral mb-5" />
        <p>
          iGEM aims to build a substantial database, that covers a wide range of
          topics and includes various formats. Within our project, we have made
          several contributions to support this global effort.
        </p>
        <figure>
          <center>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/contribution/ezgif-com-crop.gif"
              style={{ width: "70%", height: "auto" }}
              alt="animation contribution"
            />
            <i>
              <figcaption>Overview of our contributions to IGEM</figcaption>
            </i>
          </center>
        </figure>
        <p className="mt-10">
          Our contributions extend across a multitude of topics and takes
          various forms.
        </p>
        <ul
          className="ml-12 mb-10 mt-2"
          style={{
            listStyleType: "disc",
            listStylePosition: "inside",
            lineHeight: "15px",
          }}
        >
          <li>Part documentation :</li>
          <ul
            className="ml-[40px]"
            style={{ listStyleType: "disc", listStylePosition: "inside" }}
          >
            <li>Theophylline riboswitch</li>
            <li>
              IPTG + Theophylline double expression control system (with RBS)
            </li>
            <li>SpaC</li>
            <li>EC20</li>
          </ul>
          <li>
            Safety measures and protocols to safely manipulate and work with
            cadmium
          </li>
          <li>
            Enhancing the safety of LBTs to prevent horizontal gene transfer by
            engineering the Dut/Ung genes
          </li>
          <li>An open-source game to discover synthetic biology: Bioquest</li>
          <li>A competition for younger students: BSGV</li>
          <li>3D printed pieces for the lab</li>
        </ul>
        <p className="mb-20">
          On this page, we will elaborate on how each of the previous points
          contributes to the future teams participating in IGEM.
        </p>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/1.png"
            style={{ paddingRight: "0px", width: "25%", height: "25%" }}
            alt="biopart1"
          />
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <h2 id="Biological part">Biological part</h2>
            <hr class="dividergeneral" />
          </div>
        </div>
        <div>
          <div
            className="text-imageleft"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              className="text-box"
              style={{ paddingRight: "20px", width: "70%", height: "auto" }}
            >
              <h3 id="part documentation" className="ml-[-16px]">
                Part documentation : Spac and EC20{" "}
              </h3>
              <hr className="dividergeneral ml-[-16px]" />
            </div>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/contribution/5.png"
              style={{ paddingRight: "0px", width: "15%", height: "15%" }}
              alt="biopart1"
            />
            <img
              src="https://static.igem.wiki/teams/4888/wiki/contribution/6.png"
              style={{ paddingRight: "0px", width: "15%", height: "15%" }}
              alt="biopart1"
            />
          </div>
          <p className="mb-5">
            For our project, we have worked with EC20 and SpaC.
          </p>
          <p className="mb-5">
            EC20 is a cadmium-binding protein. In our project, we are sharing
            our findings and a constitutive construct to express EC20 within the
            E. coli strain. Since EC20 is already an existing IGEM part, we will
            not introduce it as a new part.
          </p>
          <p>
            SpaC is a mucus-binding protein. We are adding a new part to the
            IGEM catalog. We are providing a complete part, test and result.
          </p>
        </div>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h3 id="double inducible switch" className="ml-[-16px]">
                A double expression control system: IPTG + Theophylline (with
                RBS)
              </h3>
              <hr className="ml-[-16px]" />
            </p>
          </div>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/7.png"
            style={{ paddingRight: "0px", width: "15%", height: "15%" }}
            alt="biopart1"
          />
        </div>
        <p>
          In addition to working with EC20 and SpaC, we developed a double
          switch using IPTG and theophylline to ensure that the expression of
          SpaC only happens when outside of the body and inside our medium,
          preventing its expression inside. This double switch can be also used
          to express other proteins, for example is facing the same issue while
          creating a live biological therapeutics.
        </p>
        <p>
          We will be adding this construct as a new composite part in the iGEM
          catalog. We are providing our construct and result. Find our more in
          our <a href="../epfl/parts"> Parts page</a>
        </p>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/2.png"
            style={{ paddingRight: "0px", width: "25%", height: "25%" }}
            alt="biopart1"
          />
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h2 id="Safety">Safety </h2>
              <hr class="dividergeneral"></hr>
            </p>
          </div>
        </div>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h3 id="Cadmium protocol" className="ml-[-16px]">
                Safety measures and protocols to safely manipulate and work with
                cadmium
              </h3>
              <hr className="ml-[-16px]" />
            </p>
          </div>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/8.png"
            style={{ paddingRight: "0px", width: "15%", height: "15%" }}
            alt="biopart1"
          />
        </div>
        <p>
          Dealing with hazardous heavy metals necessitates specific safety
          precautions. To guarantee our work was conducted safely, we consulted
          experts, accessed relevant documentation, and adhered to the
          appropriate protocols established by EPFL, as explained on the safety
          page.
        </p>{" "}
        <p>
          To help potential future IGEM teams, who might work with cadmium, we
          are providing all our findings as well as our protocols.
        </p>{" "}
        <p>
          Our protocols and the summary of our findings can be found below as
          well as on the Safety page.
        </p>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h3 id="dut/ung" className="ml-[-16px]">
                Enhancing the safety of GMOs by trying to prevent horizontal
                gene transfer by combined knout-out of Dut/Ung genes.{" "}
              </h3>
              <hr className="ml-[-16px]" />
            </p>
          </div>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/9.png"
            style={{ paddingRight: "0px", width: "15%", height: "15%" }}
            alt="biopart1"
          />
        </div>
        <p>
          Given that our bacteria will engage with the microbiome, we worked on
          developing a method to prevent horizontal gene transfer, thereby
          enhancing the safety of our Live Biotherapeutic Product (LBP). We
          recognize that numerous iGEM teams are exploring diverse bacterial
          interactions with microbiomes and environments. Consequently, we
          believe that our approach could prove valuable for future iGEM teams
          working in this domain.
        </p>{" "}
        <p>
          The Dut/Ung principle is detailed in the{" "}
          <a href="../epfl/safety"> Safety page</a>, where our protocols and
          results regarding this method can be found.
        </p>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/3.png"
            style={{ paddingRight: "0px", width: "25%", height: "25%" }}
            alt="biopart1"
          />
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h2 id="Education">Education </h2>
              <hr class="dividergeneral" />
            </p>
          </div>
        </div>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h3 id="Bioquest" className="ml-[-16px]">
                An open-source game to discover synthetic biology : Bioquest
              </h3>
              <hr className="ml-[-16px]" />
            </p>
          </div>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/10.png"
            style={{ paddingRight: "0px", width: "15%", height: "15%" }}
            alt="biopart1"
          />
        </div>
        <p>
          As described on the game's webpage (with a provided link), we've
          created an open-source game centred around the exploration of
          synthetic biology. This game was meticulously crafted using the Godot
          game engine. Its primary purpose is to serve as an engaging
          educational tool for both school and home environments, enabling users
          to delve into the fundamentals of synthetic biology in an enjoyable
          manner. For instance, this game was made available to students
          participating in the BSGV program.{" "}
        </p>{" "}
        <p>
          Moreover, our game serves as a versatile template that other iGEM
          teams can adopt to showcase their own projects. Beyond covering the
          foundational aspects of synthetic biology like GFP and ampicillin,
          we've incorporated elements related to our specific gene of interest,
          Spac and EC20, by developing several levels that reflect our project's
          goals. We've encouraged collaboration with other iGEM teams,
          demonstrating that creating levels for their respective projects is
          feasible. Lastly, we've included templates and comprehensive code
          explanations, making it an excellent foundation for other students
          looking to build their own educational games.
        </p>{" "}
        <p>
          To facilitate the process of beginning to use Godot for one's own
          applications, we have provided a number of resources. At the end of
          the game's webpage, the source code and the game application itself
          are available, along with links to explore and get acquainted with
          Godot. Additionally, there's a step-by-step tutorial provided for
          using the template (which can also be found within the game) to create
          new games and seamlessly integrate them into the main game
          environment.
        </p>
        <p>
          Learn more on the dedicated <a href="../epfl/game"> game page</a>
        </p>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h3 id="BSGV" className="ml-[-16px]">
                Communicate and transfer our knowledge to younger student : BSGV
              </h3>
              <hr className="ml-[-16px]" />
            </p>
          </div>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/11.png"
            style={{ paddingRight: "0px", width: "15%", height: "15%" }}
            alt="biopart1"
          />
        </div>
        <p>
          Although iGEM is open to high school students, it can still pose a
          significant challenge due to its complexity, especially for younger
          students. Furthermore, many high schools lack the necessary materials
          and resources to undertake such a substantial project. To address this
          educational gap, we formulated a strategy as part of our educational
          plan - the creation of a competition known as BSGV. The primary goal
          of BSGV is to introduce the concepts of synthetic biology to high
          school students in our region of Switzerland.
        </p>{" "}
        <p>
          We aspire to sustain this competition in the coming years in
          collaboration with future EPFL iGEM teams. This endeavour not only
          aids in disseminating knowledge about synthetic biology but also
          fosters curiosity and interest in this field among younger students.
        </p>
        <p>
          Furthermore, all the materials developed for the BSGV competition are
          open-source and can serve as a blueprint for other iGEM teams
          interested in organizing a similar competition in their own regions.
          All the BSGV materials, including competition rules and explanations,
          promotional videos, and educational videos created by our team to
          introduce students to the fundamental concepts of synthetic biology,
          can be accessed on the <a href="../epfl/bsgv">BSGV page</a>
        </p>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/4.png"
            style={{ paddingRight: "0px", width: "25%", height: "25%" }}
            alt="biopart1"
          />
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h2 id="Laboratory">Laboratory</h2>
              <hr class="dividergeneral" />
            </p>
          </div>
        </div>
        <div
          className="text-imageleft"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            className="text-box"
            style={{ paddingRight: "20px", width: "70%", height: "auto" }}
          >
            <p>
              <h3 id="3D printed pieces" className="ml-[-16px]">
                3D printed pieces for the lab{" "}
              </h3>
              <hr className="ml-[-16px]" />
            </p>
          </div>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/contribution/12.png"
            style={{ paddingRight: "0px", width: "15%", height: "15%" }}
            alt="biopart1"
          />
        </div>
        <p>
          During our journey in the lab, we sadly encountered some trouble with
          the incubator flask clamp. The piece was broken due to the repeated
          shock and time. We decided to design a new flask clamp and 3D-print it
          to continue our experiments. This piece has been used throughout the
          entire summer and is still functional and in perfect condition.
        </p>
        <p>
          For the benefit of future iGEM teams and to contribute to the
          knowledge-sharing spirit of the community, we have made available the
          drawing of this clamp piece, along with a visual representation. We
          believe that having access to this resource could prove valuable for
          subsequent iGEM teams.
        </p>
        <p>
          <details>
            <summary>
              <mark>
                <b>Part and link to download</b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/contribution/flask-clamp.pdf"
              width="800"
              height="500"
              aria-label="Flask Clamp PDF Document"
            />
            <a
              href="https://static.igem.wiki/teams/4888/wiki/contribution/igem-clamp-doyn.stl"
              download
            >
              download link down part of the clamp
            </a>
            <a
              href="https://static.igem.wiki/teams/4888/wiki/contribution/igem-clamp-up.stl"
              download
            >
              download link up part of the clamp
            </a>
          </details>
        </p>
      </div>
    </div>
  );
};

export default Article;
